import { GET, POST } from ".";
export const OVVRequests = {
  getRequests: (id) => GET(`/api/OVVRequests/${id}`),
  addReportAttachment: (data) => POST(`/api/OVVRequests/addReport`, data),
};
